module.exports = __webpack_public_path__ + "img/fzlc-6.724e38d3.png";